import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {getJourneyInfo} from '@/services/loyalty/loyaltyUtils';
import {selectAllJourneys, selectNotCompletedActions} from '@/state/selectors/consumerLoyalty';

import {useFirstNotCompletedAction} from './useFirstNotCompletedAction';
import {useJourney} from './useJourney';

type TypeNewBadgeInfo = {
    actionLabel: string;
    actionDescription: string;
    progressCount: number;
    totalCount: number;
    journeyName?: string;
    journeyDescription?: string;
    badge: any;
};

export const useNewBadgeInfo = (journeyId?: string): TypeNewBadgeInfo | null => {
    // TODO: Test fallback for test purposes, need to be removed later
    const notCompletedActions = useSelector(selectNotCompletedActions);
    const journeys = useSelector(selectAllJourneys);

    let journey = useJourney(journeyId);
    const firstNotCompletedAction = useFirstNotCompletedAction(journey) ?? notCompletedActions[0];

    return useMemo(() => {
        if (!firstNotCompletedAction) {
            return null;
        }

        const {actionLabel, actionDescription, memberJourneyBadge} = firstNotCompletedAction;

        journey ??= journeys.find((j) => j.journeyId === memberJourneyBadge?.journeyId);

        const {progressCompleted, progressTotal} = getJourneyInfo(journey);

        return {
            actionLabel,
            actionDescription,
            progressCount: progressCompleted,
            totalCount: progressTotal,
            journeyName: journey?.journeyName,
            journeyDescription: journey?.journeyDescription,
            badge: memberJourneyBadge,
        };
    }, [journeyId, journeys, notCompletedActions]);
};
